import React, { useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useEffect } from "react";
import {
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  TextField,
  Button,
  Grid,
  Chip,
  Container,
  Modal,
  IconButton,
  Paper,
  useTheme,
  useMediaQuery,
  Drawer,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar";
import { useSections } from "./SectionContext";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";

// Import resume components
import Resume1 from "../DuplicateResume/Resume1";
import Resume2 from "../DuplicateResume/Resume2";
import Resume3 from "../DuplicateResume/Resume3";
import Resume4 from "../DuplicateResume/Resume4";
import Resume5 from "../DuplicateResume/Resume5";
import Resume6 from "../DuplicateResume/Resume6";
import Resume7 from "../DuplicateResume/Resume7";
import Resume8 from "../DuplicateResume/Resume8";
import Resume9 from "../DuplicateResume/Resume9";
import Resume10 from "../DuplicateResume/Resume10";
import Resume11 from "../DuplicateResume/Resume11";
import Resume12 from "../DuplicateResume/Resume12";
import Resume13 from "../DuplicateResume/Resume13";
import Resume14 from "../DuplicateResume/Resume14";
import Resume15 from "../DuplicateResume/Resume15";
import Resume16 from "../DuplicateResume/Resume16";
import Resume17 from "../DuplicateResume/Resume17";
import Resume18 from "../DuplicateResume/Resume18";
import Resume19 from "../DuplicateResume/Resume19";
import Resume20 from "../DuplicateResume/Resume20";
import Resume21 from "../DuplicateResume/Resume21";
import Resume22 from "../DuplicateResume/Resume22";
import Resume23 from "../DuplicateResume/Resume23";
import Resume24 from "../DuplicateResume/Resume24";
import Resume25 from "../DuplicateResume/Resume25";
import Resume26 from "../DuplicateResume/Resume26";
import Resume27 from "../DuplicateResume/Resume27";
import Resume28 from "../DuplicateResume/Resume28";
import Resume29 from "../DuplicateResume/Resume29";
import Resume30 from "../DuplicateResume/Resume30";
import Resume31 from "../DuplicateResume/Resume31";
import Resume32 from "../DuplicateResume/Resume32";
import Resume33 from "../DuplicateResume/Resume33";
import Resume34 from "../DuplicateResume/Resume34";
import Resume35 from "../DuplicateResume/Resume35";
import Resume36 from "../DuplicateResume/Resume36";
import Resume37 from "../DuplicateResume/Resume37";
import Resume38 from "../DuplicateResume/Resume38";
import Resume39 from "../DuplicateResume/Resume39";
import Resume40 from "../DuplicateResume/Resume40";
import Resume41 from "../DuplicateResume/Resume41";
import Resume42 from "../DuplicateResume/Resume42";
import Resume43 from "../DuplicateResume/Resume43";
import Resume44 from "../DuplicateResume/Resume44";
import Resume45 from "../DuplicateResume/Resume45";
import Resume46 from "../DuplicateResume/Resume46";
import Resume47 from "../DuplicateResume/Resume47";
import Resume48 from "../DuplicateResume/Resume48";
import Resume49 from "../DuplicateResume/Resume49";
import Resume50 from "../DuplicateResume/Resume50";

const templateComponents = {
  1: Resume1, 2: Resume2, 3: Resume3, 4: Resume4, 5: Resume5,
  6: Resume6, 7: Resume7, 8: Resume8, 9: Resume9, 10: Resume10,
  11: Resume11, 12: Resume12, 13: Resume13, 14: Resume14, 15: Resume15,
  16: Resume16, 17: Resume17, 18: Resume18, 19: Resume19, 20: Resume20,
  21: Resume21, 22: Resume22, 23: Resume23, 24: Resume24, 25: Resume25,
  26: Resume26, 27: Resume27, 28: Resume28, 29: Resume29, 30: Resume30,
  31: Resume31, 32: Resume32, 33: Resume33, 34: Resume34, 35: Resume35,
  36: Resume36, 37: Resume37, 38: Resume38, 39: Resume39, 40: Resume40,
  41: Resume41, 42: Resume42, 43: Resume43, 44: Resume44, 45: Resume45,
  46: Resume46, 47: Resume47, 48: Resume48, 49: Resume49, 50: Resume50,
};

const sectionsList = [
  "Websites, Portfolios, Profiles",
  "Certifications",
  "Languages",
  "Accomplishments",
  "Additional Information",
  "Software",
  "References",
  "Volunteering",
  "Interests",
];

// Map section name → route
const sectionRoutes = {
  "Websites, Portfolios, Profiles": "/WebsiteSection",
  Certifications: "/Certifications",
  Languages: "/Language",
  Accomplishments: "/AccomplishmentsSection",
  "Additional Information": "/AdditionalInfoForm",
  Software: "/SoftWare",
  References: "/Refferences",
  Volunteering: "/Volunteer",
  Interests: "/Interest",
};

// ─── Helper: safely parse a JSON string, returning fallback on error ──────────
const safeParseJSON = (str, fallback) => {
  try {
    const parsed = JSON.parse(str);
    return parsed !== null && parsed !== undefined ? parsed : fallback;
  } catch {
    return fallback;
  }
};

export default function ExtraSections() {
  const [selectedSections, setSelectedSections] = useState([]);
  const [customSections, setCustomSections] = useState([]);
  const [customInput, setCustomInput] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [currentCustomSections, setCurrentCustomSections] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // ─── Initialize template & theme from location.state first,
  //     then fall back to localStorage so back-navigation never loses the choice ─
  const getInitialTemplate = () => {
    if (location.state?.selectedTemplate) return location.state.selectedTemplate;
    return safeParseJSON(localStorage.getItem("selectedTemplate"), 1);
  };

  const getInitialTheme = () => {
    if (location.state?.selectedTheme) return location.state.selectedTheme;
    return safeParseJSON(localStorage.getItem("selectedTheme"), "#1a2b47");
  };

  const [selectedTemplate, setSelectedTemplate] = useState(getInitialTemplate);
  const [selectedTheme, setSelectedTheme] = useState(getInitialTheme);

  const [workExperiences, setWorkExperiences] = useState([]);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    currentPosition: "",
    city: "",
    country: "India",
    pinCode: "",
    phone: "",
    email: "",
    linkedIn: "",
    website: "",
    drivingLicence: "",
  });
  const [preview, setPreview] = useState("");

  // ---- mobile full-size preview scaling + auto-straighten ----
  const previewContentRef = useRef(null);
  const [mobilePreviewSize, setMobilePreviewSize] = useState({
    scale: 1,
    width: 0,
    height: 0,
    rotation: 0,
  });

  const findRotationDeg = (root) => {
    if (!root) return 0;
    let maxAbsAngle = 0;
    let maxAngle = 0;

    const walk = (el, depth) => {
      if (!el || depth > 6) return;
      const style = window.getComputedStyle(el);
      const t = style.transform;
      if (t && t !== "none") {
        const match = t.match(/matrix\(([^,]+),\s*([^,]+),/);
        if (match) {
          const a = parseFloat(match[1]);
          const b = parseFloat(match[2]);
          const angle = Math.atan2(b, a) * (180 / Math.PI);
          if (Math.abs(angle) > maxAbsAngle) {
            maxAbsAngle = Math.abs(angle);
            maxAngle = angle;
          }
        }
      }
      if (el.children) {
        for (let i = 0; i < el.children.length; i++) {
          walk(el.children[i], depth + 1);
        }
      }
    };

    walk(root, 0);
    return maxAngle;
  };

  // ─── Persist template & theme to localStorage whenever they change ────────
  useEffect(() => {
    localStorage.setItem("selectedTemplate", JSON.stringify(selectedTemplate));
  }, [selectedTemplate]);

  useEffect(() => {
    localStorage.setItem("selectedTheme", JSON.stringify(selectedTheme));
  }, [selectedTheme]);

  // ─── Sync from location.state when navigation supplies fresh values ────────
  useEffect(() => {
    if (location.state) {
      const { selectedTemplate: tmpl, selectedTheme: thm } = location.state;
      if (tmpl) {
        setSelectedTemplate(tmpl);
        localStorage.setItem("selectedTemplate", JSON.stringify(tmpl));
      }
      if (thm) {
        setSelectedTheme(thm);
        localStorage.setItem("selectedTheme", JSON.stringify(thm));
      }
    }

    // Load work experiences from localStorage
    const savedWorks = localStorage.getItem("workExperiences");
    if (savedWorks) {
      setWorkExperiences(JSON.parse(savedWorks));
    }

    // Fetch contact data
    const fetchContactData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

        const res = await axios.get("https://resume-maker-lc.onrender.com/api/contact/me", {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (res.data) {
          setFormData({
            firstName: res.data.firstName || "",
            lastName: res.data.lastName || "",
            currentPosition: res.data.currentPosition || "",
            city: res.data.city || "",
            country: res.data.country || "India",
            pinCode: res.data.pinCode || "",
            phone: res.data.phone || "",
            email: res.data.email || "",
            linkedIn: res.data.linkedIn || "",
            website: res.data.website || "",
            drivingLicence: res.data.drivingLicence || "",
          });

          if (res.data.photo) {
            setPreview(
              res.data.photo.startsWith("http")
                ? res.data.photo
                : `https://resume-maker-lc.onrender.com${res.data.photo}`
            );
          }
        }
      } catch (err) {
        console.error("Error fetching contact", err);
      }
    };

    const userId = localStorage.getItem("userId");
    if (userId) {
      localStorage.removeItem(`current_custom_sections_${userId}`);
      console.log("🧹 Cleared previous current custom sections");
    }

    fetchContactData();
  }, [location.state]);

  // ---- measure resume's natural size for mobile preview ----
  useEffect(() => {
    if (!previewOpen || !isMobile) return;

    const measure = () => {
      if (previewContentRef.current) {
        const naturalWidth = previewContentRef.current.scrollWidth;
        const naturalHeight = previewContentRef.current.scrollHeight;
        const availableWidth = window.innerWidth * 0.95 - 32;

        const rootEl =
          previewContentRef.current.firstElementChild || previewContentRef.current;
        const rotation = findRotationDeg(rootEl);

        if (naturalWidth > 0) {
          const scale = Math.min(availableWidth / naturalWidth, 1);
          setMobilePreviewSize({
            scale,
            width: naturalWidth * scale,
            height: naturalHeight * scale,
            rotation,
          });
        }
      }
    };

    const timer = setTimeout(measure, 100);
    window.addEventListener("resize", measure);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", measure);
    };
  }, [previewOpen, isMobile, selectedTemplate, selectedTheme]);

  const { setSelectedSections: saveSections } = useSections();

  const SelectedResumeComponent = templateComponents[selectedTemplate] || templateComponents[1];

  const getResumeProps = () => {
    switch (selectedTemplate) {
      case 2:
        return { color: selectedTheme, workExperiences, formData, photo: preview };
      case 3:
        return {
          color: typeof selectedTheme === "object" ? selectedTheme.primary : selectedTheme,
          workExperiences,
          formData,
          photo: preview,
        };
      case 4:
        return {
          theme: selectedTheme,
          color: typeof selectedTheme === "object" ? selectedTheme.primary : selectedTheme,
          workExperiences,
          formData,
          photo: preview,
        };
      case 7:
        return {
          theme: selectedTheme,
          color: typeof selectedTheme === "object" ? selectedTheme.highlight : selectedTheme,
          workExperiences,
          formData,
          photo: preview,
        };
      case 8:
        return { theme: selectedTheme, workExperiences, formData, photo: preview };
      default:
        return { color: selectedTheme, workExperiences, formData, photo: preview };
    }
  };

  // Toggle predefined section
  const handleToggle = (section) => {
    if (selectedSections.includes(section)) {
      setSelectedSections(selectedSections.filter((s) => s !== section));
    } else {
      setSelectedSections([...selectedSections, section]);
    }
  };

  // Add custom section
  const handleAddCustom = () => {
    const trimmed = customInput.trim();
    if (trimmed && !customSections.includes(trimmed)) {
      const userId = localStorage.getItem("userId");
      if (userId) {
        const userCustomKey = `custom_${userId}_${trimmed}`;
        const initialData = {
          sectionName: trimmed,
          items: [],
          userId: userId,
          created: new Date().toISOString(),
        };
        localStorage.setItem(userCustomKey, JSON.stringify(initialData));
        console.log("➕ Initialized new custom section:", trimmed, "for user:", userId);
      }

      const updatedCustomSections = [...customSections, trimmed];
      setCustomSections(updatedCustomSections);

      if (userId) {
        localStorage.setItem(
          `current_custom_sections_${userId}`,
          JSON.stringify(updatedCustomSections)
        );
        console.log("💾 Stored current custom sections:", updatedCustomSections);
      }

      setCustomInput("");
    }
  };

  // Handle Next
  const handleNext = () => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      localStorage.setItem(
        `current_custom_sections_${userId}`,
        JSON.stringify(customSections)
      );
      console.log("💾 Saved current custom sections before navigation:", customSections);
    }

    const allSections = [...selectedSections, ...customSections];
    saveSections(allSections);

    const firstSection = allSections[0];

    if (firstSection) {
      if (sectionRoutes[firstSection]) {
        navigate(sectionRoutes[firstSection], {
          state: { selectedTemplate, selectedTheme },
        });
      } else {
        navigate(`/custom-section/${encodeURIComponent(firstSection)}`, {
          state: { selectedTemplate, selectedTheme },
        });
      }
    } else {
      navigate("/mainpage", {
        state: { selectedTemplate, selectedTheme },
      });
    }
  };

  const handlePreviewOpen = () => setPreviewOpen(true);
  const handlePreviewClose = () => setPreviewOpen(false);
  const toggleMobileSidebar = () => setMobileSidebarOpen(!mobileSidebarOpen);

  // ─── Go Back — always pass the persisted template & theme ─────────────────
  const handleGoBack = () => {
    navigate("/ResumeSummarySection", {
      state: { selectedTemplate, selectedTheme },
    });
  };

  return (
    <Box display="flex" minHeight="100vh" sx={{ backgroundColor: "#EFF7FF" }}>
      {/* Desktop Sidebar */}
      {!isMobile && <Sidebar />}

      {/* Mobile Sidebar Drawer */}
      {isMobile && (
        <>
          <IconButton
            onClick={toggleMobileSidebar}
            sx={{
              position: "fixed",
              top: 16,
              left: 16,
              zIndex: 1300,
              backgroundColor: "white",
              boxShadow: 2,
              "&:hover": { backgroundColor: "#B3D9F7" },
            }}
          >
            <MenuIcon />
          </IconButton>

          <Drawer
            variant="temporary"
            open={mobileSidebarOpen}
            onClose={toggleMobileSidebar}
            ModalProps={{ keepMounted: true }}
            sx={{
              display: { xs: "block", md: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: 280,
                backgroundColor: "#EFF7FF",
              },
            }}
          >
            <Sidebar onMobileClose={toggleMobileSidebar} />
          </Drawer>
        </>
      )}

      {/* Main Content Section */}
      <Container
        maxWidth="lg"
        sx={{
          p: isSmallMobile ? 2 : isMobile ? 3 : 5,
          width: "100%",
          marginLeft: isMobile ? 0 : "230px",
          marginRight: "auto",
          pt: isMobile ? 8 : 5,
          backgroundColor: "#EFF7FF",
        }}
      >
        {/* Back Button */}
        <Typography
          variant="body2"
          sx={{
            color: "#002B5B",
            fontWeight: "bold",
            mb: 1,
            cursor: "pointer",
            "&:hover": { color: "#0288D1", textDecoration: "underline" },
            transition: "color 0.3s ease",
            fontSize: isSmallMobile ? "0.875rem" : "inherit",
          }}
          onClick={handleGoBack}
        >
          ← Go Back
        </Typography>

        {/* Title */}
        <Typography
          variant={isMobile ? "h6" : "h5"}
          fontWeight="bold"
          gutterBottom
          sx={{
            fontSize: isSmallMobile ? "1.25rem" : "inherit",
            color: "#002B5B",
            borderBottom: "3px solid #0288D1",
            pb: 1,
          }}
        >
          Do you have anything else to add?
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mb: 3,
            fontSize: isSmallMobile ? "0.875rem" : "inherit",
            color: "#0D4C8B",
          }}
        >
          These sections are optional.
        </Typography>

        <Box sx={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: 4 }}>
          {/* Left Side - Form Content */}
          <Box sx={{ flex: 1, maxWidth: isMobile ? "100%" : "600px" }}>
            {/* Predefined Sections */}
            <Grid container spacing={2} sx={{ width: "100%" }}>
              {sectionsList.map((section, i) => (
                <Grid item xs={12} key={i}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedSections.includes(section)}
                        onChange={() => handleToggle(section)}
                        size={isSmallMobile ? "small" : "medium"}
                        sx={{
                          color: "#B3D9F7",
                          "&.Mui-checked": { color: "#002B5B" },
                        }}
                      />
                    }
                    label={
                      <Typography
                        sx={{
                          fontSize: isSmallMobile ? "0.875rem" : "inherit",
                          color: "#0D4C8B",
                        }}
                      >
                        {section}
                      </Typography>
                    }
                  />
                </Grid>
              ))}
            </Grid>

            {/* Custom Sections */}
            <Box
              sx={{
                mt: 3,
                display: "flex",
                alignItems: "center",
                gap: 2,
                flexDirection: isSmallMobile ? "column" : "row",
              }}
            >
              <TextField
                placeholder="Add Your Own Section"
                value={customInput}
                onChange={(e) => setCustomInput(e.target.value)}
                fullWidth
                size={isSmallMobile ? "small" : "medium"}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: "#B3D9F7" },
                    "&:hover fieldset": { borderColor: "#B3D9F7" },
                    "&.Mui-focused fieldset": { borderColor: "#002B5B", borderWidth: 2 },
                  },
                }}
              />
              <Button
                variant="outlined"
                onClick={handleAddCustom}
                sx={{
                  width: isSmallMobile ? "100%" : "auto",
                  minWidth: isSmallMobile ? "auto" : 100,
                  borderColor: "#002B5B",
                  color: "#002B5B",
                  "&:hover": {
                    borderColor: "#0288D1",
                    color: "#0288D1",
                    backgroundColor: "rgba(2,136,209,0.04)",
                  },
                }}
              >
                Add
              </Button>
            </Box>

            {/* Show added custom sections */}
            {customSections.length > 0 && (
              <Box sx={{ mt: 2 }}>
                {customSections.map((section, i) => (
                  <Chip
                    key={i}
                    label={section}
                    sx={{
                      mr: 1,
                      mb: 1,
                      backgroundColor: "#002B5B",
                      color: "white",
                      "&:hover": { backgroundColor: "#0288D1" },
                    }}
                    size={isSmallMobile ? "small" : "medium"}
                  />
                ))}
              </Box>
            )}

            {/* Bottom Buttons */}
            <Box
              sx={{
                display: "flex",
                gap: 2,
                mt: 5,
                flexDirection: isSmallMobile ? "column" : "row",
              }}
            >
              <Button
                variant="outlined"
                sx={{
                  borderRadius: 3,
                  px: isSmallMobile ? 2 : 4,
                  flex: isSmallMobile ? 1 : "none",
                  width: isSmallMobile ? "100%" : "auto",
                  borderColor: "#002B5B",
                  color: "#002B5B",
                  "&:hover": {
                    borderColor: "#0288D1",
                    color: "#0288D1",
                    backgroundColor: "rgba(2,136,209,0.04)",
                  },
                }}
                onClick={handlePreviewOpen}
              >
                Preview
              </Button>
              <Button
                variant="contained"
                sx={{
                  bgcolor: "#002B5B",
                  borderRadius: 3,
                  px: isSmallMobile ? 2 : 4,
                  flex: isSmallMobile ? 1 : "none",
                  width: isSmallMobile ? "100%" : "auto",
                  "&:hover": {
                    bgcolor: "#0288D1",
                    transform: "translateY(-2px)",
                    boxShadow: "0 4px 12px rgba(2,136,209,0.3)",
                  },
                  transition: "all 0.3s ease",
                }}
                onClick={handleNext}
              >
                Next
              </Button>
            </Box>
          </Box>

          {/* Right Side - Small Resume Preview (Hidden on small mobile) */}
          {!isSmallMobile && (
            <Box
              sx={{
                display: "flex",
                justifyContent: isMobile ? "flex-start" : "center",
                maxHeight: isMobile ? 400 : 600,
                overflow: "hidden",
                paddingLeft: isMobile ? "10%" : 0,
                flex: 1,
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  maxWidth: 600,
                  transform: isMobile ? "scale(0.3)" : "scale(0.4)",
                  transformOrigin: isMobile ? "top left" : "top center",
                }}
              >
                <SelectedResumeComponent {...getResumeProps()} />
              </Box>
            </Box>
          )}
        </Box>
      </Container>

      {/* Preview Modal */}
      <Modal
        open={previewOpen}
        onClose={handlePreviewClose}
        aria-labelledby="resume-preview-modal"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: isSmallMobile ? 1 : 2,
        }}
      >
        <Paper
          sx={{
            position: "relative",
            width: "95%",
            maxWidth: "800px",
            maxHeight: "95vh",
            overflow: "auto",
            p: isSmallMobile ? 1 : 2,
            backgroundColor: "#EFF7FF",
          }}
        >
          {/* Close Button */}
          <IconButton
            onClick={handlePreviewClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              zIndex: 10,
              bgcolor: "background.paper",
              "&:hover": { bgcolor: "#B3D9F7" },
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Resume Preview Content */}
          <Box sx={{ display: "flex", justifyContent: "center", p: isSmallMobile ? 1 : 2 }}>
            {isMobile ? (
              <Box
                sx={{
                  width: mobilePreviewSize.width || "100%",
                  height: mobilePreviewSize.height || "auto",
                  overflow: "hidden",
                  mx: "auto",
                }}
              >
                <Box
                  ref={previewContentRef}
                  sx={{
                    transform: `rotate(${-mobilePreviewSize.rotation}deg) scale(${mobilePreviewSize.scale})`,
                    transformOrigin: "top left",
                  }}
                >
                  <SelectedResumeComponent {...getResumeProps()} />
                </Box>
              </Box>
            ) : (
              <Box
                sx={{
                  width: "100%",
                  transform: isSmallMobile ? "scale(0.7)" : "scale(0.9)",
                  transformOrigin: "top center",
                }}
              >
                <SelectedResumeComponent {...getResumeProps()} />
              </Box>
            )}
          </Box>

          {/* Action Buttons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 2,
              mt: 2,
              flexDirection: isSmallMobile ? "column" : "row",
            }}
          >
            <Button
              variant="outlined"
              onClick={handlePreviewClose}
              sx={{
                borderRadius: 3,
                px: 4,
                width: isSmallMobile ? "100%" : "auto",
                borderColor: "#002B5B",
                color: "#002B5B",
                "&:hover": {
                  borderColor: "#0288D1",
                  color: "#0288D1",
                  backgroundColor: "rgba(2,136,209,0.04)",
                },
              }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              sx={{
                bgcolor: "#002B5B",
                borderRadius: 3,
                px: 4,
                width: isSmallMobile ? "100%" : "auto",
                "&:hover": { bgcolor: "#0288D1" },
              }}
              onClick={() => {
                handlePreviewClose();
                handleNext();
              }}
            >
              Continue to Next
            </Button>
          </Box>
        </Paper>
      </Modal>
    </Box>
  );
}